import {Component, OnInit} from '@angular/core';
import {Chunker} from '../framework/chunker';
import {AnomalyEntity, AnomalyResult, QARService, SystemEntity} from '../services/qar.service';


@Component({
	selector: 'app-page-help',
	templateUrl: './help.html',
	providers: [QARService]
})
export class HelpPageComponent  {

	constructor(public apiQAR: QARService) {

	}

}
